"use client";

let scriptLoadPromise: Promise<void> | null = null;

function loadCheckoutScript(): Promise<void> {
  if (window.Razorpay) return Promise.resolve();
  if (scriptLoadPromise) return scriptLoadPromise;

  scriptLoadPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Could not load Razorpay Checkout."));
    document.body.appendChild(script);
  });
  return scriptLoadPromise;
}

/**
 * Opens Razorpay's hosted Checkout modal and resolves once the customer completes payment
 * inside it. Razorpay Checkout doesn't redirect the browser like Cashfree/PhonePe do -- the
 * caller is responsible for what happens next (see BookingFlow.tsx, which sends the customer
 * to the same /book/confirmation page the redirect-based gateways use).
 */
export function openRazorpayCheckout(
  checkout: { orderId: string; keyId: string; amountPaise: number },
  details: { name: string; description: string; prefillEmail: string; prefillContact: string }
): Promise<void> {
  return loadCheckoutScript().then(
    () =>
      new Promise<void>((resolve, reject) => {
        const instance = new window.Razorpay({
          key: checkout.keyId,
          amount: checkout.amountPaise,
          currency: "INR",
          name: details.name,
          description: details.description,
          order_id: checkout.orderId,
          prefill: { email: details.prefillEmail, contact: details.prefillContact },
          handler: () => resolve(),
          modal: { ondismiss: () => reject(new Error("Payment cancelled.")) },
        });
        instance.open();
      })
  );
}
